module.exports = __webpack_public_path__ + "static/media/lightboxreply.55a3dd70.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lightboxreply.svg
// module id = 908
// module chunks = 1